<div class="flex gap-3 flex-wrap mt-3">
    <div class="flex-nowrap flex gap-2 align-items-center" *ngIf="questionPageHiddenLog > 0">
        <img src="assets/vinter/icons/cheating-icon.svg">
        <p class="font-medium page-hidden">{{"Key.SwitchTab" | translate: {value: questionPageHiddenLog } }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.isFaceDetected && answer?.isAllowedDifferentFaceAnalysis"
        class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-icon.svg" class="detect-img">
        <p class="font-medium face-detected">{{"Key.FaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.isMultiFaceDetected && answer?.isAllowedDifferentFaceAnalysis"
        class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/multiface-detected-icon.svg" class="detect-img">
        <p class="font-medium multiface-detected">{{"Key.MultiFaceDetected" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.improprietyAnalysis?.isImproprietySpeech && answer?.isAllowedDifferentFaceAnalysis"
        class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/impropriety-speech-warning.svg" class="detect-img">
        <p class="font-medium impropriety-speech">{{"Key.ImproprietySpeechAnalysis" | translate }}</p>
    </div>
    <div *ngIf="answer?.answerContent?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace ||
     answer?.answerContent?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace"
        class="flex-nowrap flex gap-2 align-items-center">
        <img src="assets/vinter/icons/face-detection-status-icon.svg" class="detect-img">
        <p class="font-medium impropriety-speech">{{"Key.FaceDetectionStatus" | translate }}</p>
    </div>
</div>

<div class="flex">
    <img src="assets/vinter/icons/text-questioncoktan-secmeli-cevap-icon-arrow-back-up.svg">
    <h5 class="text-justify answer-title font-semibold text-lg ml-2">
        {{"Key.Answer" | translate}}
    </h5>
</div>

<div class="flex ml-5" *ngIf="answer == null">
    <img src="assets/vinter/icons/not-answered.svg">
    <p class="ml-2 empty-answer-text">{{"Key.QuestionNotAnswered" | translate}}</p>
</div>

<div *ngIf="answer?.answerContent ?? false" class="answer-container">
    <div
        class="grid flex-wrap p-4 border-gray-50 border-round-lg border-1 border-solid card-container justify-content-center">
        <div class="custom-col-6 flex height-fit">
            <vg-player *ngIf="answer?.answerContent?.contentURL ?? false" style="border-radius: 15px;">
                <video #targetVideo [vgMedia]="$any(media)" #media id="singleVideo" preload="auto" controls
                    (timeupdate)="highlightPronunciation($event.target)">
                    <source [src]="answer?.answerContent?.contentURL" type="video/webm">
                    <source [src]="answer?.answerContent?.contentURL" type="video/mp4">
                </video>
            </vg-player>
        </div>
    </div>
    <hr *ngIf="answer?.answerContent?.gptEvalStatus === gptEvalStatusEnum.Succesful">
</div>